// extracted by mini-css-extract-plugin
export default {"wrapper":"SurveyNavigation_wrapper__NSZPC","progressBar":"SurveyNavigation_progressBar__Z08TL","buttonsWrapper":"SurveyNavigation_buttonsWrapper__o3RNu"};